<app-claim-filter
  *ngIf="userClaims?.length"
  class="modal-content"
  [viewStatus]="false"
  (filters)="onFiltersApplied($event)"
  (cancel)="onFilterCancel()"
  [filterKey]="onFilterKey!"
></app-claim-filter>
<p-table
  [tableStyle]="{ 'min-width': '100%' }"
  [rowHover]="true"
  *ngIf="skeleton"
  [value]="skeletons"
  class="fadein animation-duration-500"
>
  <ng-template pTemplate="header">
    <tr class="font-bold text-xs sm:text-md">
      <th style="width: 15%">Reclamante</th>
      <th *ngIf="!isPluri" style="width: 15%">Reclamado</th>
      <th *ngIf="isPluri" style="width: 15%">Reclamado/Representados</th>
      <th style="width: 15%">Nº de reclamo</th>
      <th style="width: 15%">Nº de expte.</th>
      <th class="text-center" style="width: 15%">Rol</th>
      <th style="width: 15%">Conciliador/Administrador</th>
      <th style="width: 15%">Acciones</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-skeleton>
    <tr>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
      <td class="text-center"><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>

<p-table
  [value]="claim!"
  *ngIf="!skeleton && haveResults"
  [tableStyle]="{ 'min-width': '100%' }"
  class="fadein animation-duration-500"
>
  <ng-template pTemplate="header">
    <tr class="font-bold text-xs sm:text-md">
      <th class="text-left" style="width: 15%">Reclamante</th>
      <th *ngIf="isPluri" style="width: 15%">Reclamado/Representados</th>
      <th *ngIf="!isPluri" class="text-left" style="width: 15%">Reclamado</th>
      <th class="text-center" style="width: 15%">Nº de reclamo</th>
      <th class="text-center" style="width: 15%">Nº de expte.</th>
      <th class="text-center" style="width: 15%">Rol</th>
      <th>Conciliador/Administrador</th>
      <th class="text-center" style="width: 10%">Acciones</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-claim>
    <tr class="table-row text-xs sm:text-sm">
      <td class="text-left">
        {{
          claim.representative_name
            ? (claim.representative_name + " " + claim.representative_last_name
              | truncate)
            : claim.razon_social
            ? (claim.razon_social | truncate)
            : claim.claimentName
            ? (claim.claimentName + " " + claim.claimentLastName | truncate)
            : "-"
        }}
      </td>
      <td *ngIf="!isPluri" class="text-left">
        {{
          claim.claimed_collective_agreement
            ? (claim.claimed_collective_agreement | truncate)
            : claim.nameLastNameOrBusinessNameClaimed
            ? (claim.nameLastNameOrBusinessNameClaimed | truncate)
            : "-"
        }}
      </td>
      <td *ngIf="isPluri" class="text-left">
        <p *ngIf="claim.rol == 'Representante gremial'">
          Reclamado:
          <span class="font-bold">
            {{ claim.razon_social ? (claim.razon_social | truncate) : "-" }}
          </span>
        </p>
        {{
          claim.rol == "Representante gremial"
            ? "Cantidad de representados:"
            : "Cantidad de reclamados:"
        }}
        <span class="count-employees"> {{ claim.count_employees }} </span>
      </td>
      <td class="text-center">
        {{ claim.number_of_claim ? claim.number_of_claim : "-" }}
      </td>
      <td class="text-center">
        {{ claim.expediente_claim ? claim.expediente_claim : "-" }}
      </td>
      <td style="width: 10%" class="text-center">
        <span class="px-3" [ngClass]="getClassForRole(claim.rol)">
          {{ claim.rol | truncate }}
        </span>
      </td>
      <td style="width: 10%">
        {{
          claim.conciliatorFullName
            ? claim.conciliatorFullName
            : claim.conciliator_full_name
            ? claim.conciliator_full_name
            : "No asignado"
        }}
      </td>
      <td class="text-center" style="width: 10%">
        <i
          (click)="view(claim.id ? claim.id : claim._id)"
          class="pi pi-eye cursor-pointer"
          style="font-size: 1.25rem"
          title="Ver reclamo"
        ></i>
      </td>
    </tr>
  </ng-template>
</p-table>

<div
  *ngIf="!haveResults || !userClaims?.length"
  class="flex flex-column align-items-center fadein animation-duration-500"
>
  <img
    src="../../../../../../assets/img/main/file-searching.svg"
    alt="imagen de archivo"
    style="width: 200px; height: 200px"
  />
  <p>No hay reclamos para visualizar</p>
</div>

<p-paginator
  *ngIf="pagination.totalQuantity"
  (onPageChange)="changePage($event)"
  [first]="(pagination.actualPage - 1) * pagination.itemsPerPage"
  [rows]="pagination.itemsPerPage"
  [totalRecords]="pagination.totalQuantity"
  [rowsPerPageOptions]="[5, 10, 25, 50]"
>
</p-paginator>
